module.exports = __webpack_public_path__ + "static/media/P3.8e60afa0.jpg";